import * as React from "react";
const SvgFiRrUserCrown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-crown_svg__a)">
      <path
        fill="#062147"
        d="M19.142 23.99a.999.999 0 0 1-1.131-.848C17.592 20.21 15.008 18 12.001 18s-5.59 2.21-6.01 5.142a1.007 1.007 0 0 1-1.13.85 1 1 0 0 1-.849-1.133c.56-3.91 3.994-6.858 7.99-6.858s7.431 2.948 7.99 6.858a1 1 0 0 1-.848 1.132zM6 8V.764c0-.754.978-1.05 1.397-.423L9 3.001 11.297.32a.926.926 0 0 1 1.406 0L15 3 16.603.34C17.023-.287 18 .011 18 .764V8c0 3.31-2.69 6-6 6s-6-2.69-6-6m2-1v1c0 2.206 1.794 4 4 4s4-1.794 4-4V7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-crown_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserCrown;
